import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  getAdminSuppliers,
  getSupplierFeatures,
  setSupplierFeature,
} from "../../../services";
import { AdminSupplier, SupplierFeature } from "../../../types/featureFlags";
import { QUERY_KEYS } from "../queryKeys";

export const useGetAdminSuppliers = () => {
  return useQuery<AdminSupplier[], Error>({
    queryKey: [QUERY_KEYS.GET_ADMIN_SUPPLIERS],
    queryFn: () => getAdminSuppliers(),
    refetchOnWindowFocus: false,
  });
};

export const useGetSupplierFeatures = (supplierId?: number) => {
  return useQuery<SupplierFeature[], Error>({
    queryKey: [QUERY_KEYS.GET_SUPPLIER_FEATURES, supplierId],
    queryFn: () => getSupplierFeatures(supplierId!),
    enabled: !!supplierId,
    refetchOnWindowFocus: false,
  });
};

export const useUpdateSupplierFeature = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      supplierId,
      featureId,
      is_enabled,
    }: {
      supplierId: number;
      featureId: number;
      is_enabled: boolean;
    }) => setSupplierFeature(supplierId, featureId, is_enabled),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.GET_SUPPLIER_FEATURES, variables.supplierId],
      });
    },
  });
};
